import React, { useState } from "react";

import { SearchInput } from "../../../components/ui";

export function LookbookSearchBar({
  onUpdate,
  delay = 500,
  placeholder = "Quick search for products",
}) {
  const [value, setValue] = useState("");
  const [delayTimeout, setDelayTimeout] = useState();

  const onChange = (e) => {
    if (delayTimeout) clearTimeout(delayTimeout);
    const newValue = e.target.value;
    setValue(newValue);
    setDelayTimeout(
      setTimeout(() => {
        onUpdate(newValue);
      }, delay)
    );
  };

  const onClear = () => {
    if (delayTimeout) clearTimeout(delayTimeout);
    setValue("");
    onUpdate("");
  };

  return (
    <SearchInput
      size="xl"
      className="lb-search-bar"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onClear={onClear}
      aria-label={placeholder}
    />
  );
}
